<div
  class="my-5 flex flex-col gap-2 px-4"
  [class.has-error]="
    permissionControl.touched && permissionControl.hasError('required')
  "
>
  <p class="mb-1 text-sm font-bold">Hozzáférési jogok</p>
  <mat-checkbox
    class="w-fit text-sm"
    [checked]="isCheckboxSelected(AdminPermissionVM.ClaimManagement)"
    (change)="onCheckboxChange(AdminPermissionVM.ClaimManagement)"
    >Követelés kezelés</mat-checkbox
  >
  <mat-checkbox
    class="w-fit text-sm"
    [checked]="isCheckboxSelected(AdminPermissionVM.BlackListManagement)"
    (change)="onCheckboxChange(AdminPermissionVM.BlackListManagement)"
    >Feketelista</mat-checkbox
  >
  <mat-checkbox
    class="w-fit text-sm"
    [checked]="isCheckboxSelected(AdminPermissionVM.AdminManagement)"
    (change)="onCheckboxChange(AdminPermissionVM.AdminManagement)"
    >Admin kezelés</mat-checkbox
  >
  <mat-checkbox
    class="w-fit text-sm"
    [checked]="isCheckboxSelected(AdminPermissionVM.CopyManagement)"
    (change)="onCheckboxChange(AdminPermissionVM.CopyManagement)"
    >Copy management</mat-checkbox
  >
  <mat-checkbox
    class="w-fit text-sm"
    [checked]="isCheckboxSelected(AdminPermissionVM.StationManagement)"
    (change)="onCheckboxChange(AdminPermissionVM.StationManagement)"
    >Station management</mat-checkbox
  >
  <mat-checkbox
    class="w-fit text-sm"
    [checked]="isCheckboxSelected(AdminPermissionVM.CarManagement)"
    (change)="onCheckboxChange(AdminPermissionVM.CarManagement)"
    >Car management</mat-checkbox
  >
  <mat-checkbox
    class="w-fit text-sm"
    [checked]="isCheckboxSelected(AdminPermissionVM.RentalManagement)"
    (change)="onCheckboxChange(AdminPermissionVM.RentalManagement)"
    >Booking management</mat-checkbox
  >
  <mat-error
    class="checkbox-error text-xs"
    [class.show-error]="
      permissionControl.touched && permissionControl.hasError('required')
    "
  >
    Válasszon ki legalább egy hozzáférési jogot.
  </mat-error>
</div>
